export function parseISODate(iso: string): Date {
  const [y = 0, m = 1, d = 1] = iso.split('-').map(Number);
  return new Date(y, m - 1, d);
}

export function toISODate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function addDays(d: Date, n: number): Date {
  const r = new Date(d);
  r.setDate(r.getDate() + n);
  return r;
}

export function addMonths(d: Date, n: number): Date {
  return new Date(d.getFullYear(), d.getMonth() + n, d.getDate());
}

export function startOfMonth(d: Date): Date {
  return new Date(d.getFullYear(), d.getMonth(), 1);
}

const dayNum = (d: Date): number => d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();

export function isSameDay(a: Date, b: Date): boolean {
  return dayNum(a) === dayNum(b);
}

export function isBeforeDay(a: Date, b: Date): boolean {
  return dayNum(a) < dayNum(b);
}

export function isAfterDay(a: Date, b: Date): boolean {
  return dayNum(a) > dayNum(b);
}

/**
 * Matriz de 6 semanas (42 celdas) del mes indicado, empezando en lunes.
 */
export function getMonthMatrix(month: Date): Date[] {
  const first = startOfMonth(month);
  const offset = (first.getDay() + 6) % 7; // lunes = 0
  const start = addDays(first, -offset);
  return Array.from({ length: 42 }, (_, i) => addDays(start, i));
}

const toDMY = (iso: string): string => {
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
};

export function formatRangeLabel(from: string | null, to: string | null): string {
  if (from && to) return `${toDMY(from)} – ${toDMY(to)}`;
  if (from) return `${toDMY(from)} –`;
  return '';
}
